/**
 * Sticky behaviour.
 */

(function (Drupal, $) {
  "use strict";

  Drupal = Drupal || {};

  Formstone.NoConflict();
  
  /**
   * JS Behaviour.
   *
   * @type {{attach: Drupal.behaviors.sticky.attach}}
   */
  Drupal.behaviors.sticky = {
    attach: function (context, settings) {
      $('[data-sticky]').once('sticky', function (e) {
        $('[data-sticky]').fsSticky();
      });
    }
  }

})(Drupal, jQuery);
